import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import '../css/colaboradores.css';
import Colaboradores from "./Colaboradores";

function PageColaboradores() {






  return (
    <main className="main">
      <div className="page">
        
        {/* --- ENCABEZADO MÁGICO --- */}
        <header className="colaboradores-header">
          <h2 className="colaboradores-title">Colaboradores</h2>
          <p className="agradecimiento-texto">
            Este reto no sería posible sin el corazón y la entrega de las personas y empresas que nos acompañan. 
            Gracias por ayudarnos a dibujar sonrisas y por creer en la magia de la solidaridad.
          </p>
          <div className="header-divider-colab"></div>
        </header>

        {/* --- GRID DE COLABORADORES CUADRADOS --- */}
      <div>
        <Colaboradores/>
      </div>

      </div>
    </main>
  );
}

export default PageColaboradores;